(()=>{'use strict';
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const menu=$('.mobilemenu');if(menu)menu.addEventListener('click',()=>{const nav=$('#mobile-navigation');nav.hidden=!nav.hidden;menu.setAttribute('aria-expanded',String(!nav.hidden))});
$$('[data-product-discovery]').forEach(region=>{
 const filters=$('[data-need-filters]',region);if(!filters)return;
 const buttons=$$('button[data-need]',filters),cards=$$('[data-product-grid] .product-card',region),count=$('[data-filter-count]',region);
 filters.hidden=false;count.hidden=false;
 function filter(need,persist=false){if(!buttons.some(b=>b.dataset.need===need))need='all';
  buttons.forEach(b=>{const selected=b.dataset.need===need;b.classList.toggle('active',selected);b.setAttribute('aria-pressed',String(selected));b.hidden=b.dataset.need!=='all'&&!cards.some(c=>c.dataset.need===b.dataset.need)});
  cards.forEach(c=>c.hidden=need!=='all'&&c.dataset.need!==need);
  const total=cards.filter(c=>!c.hidden).length;count.textContent=total+' product'+(total===1?'':'s')+(need==='all'?' to explore':' for '+buttons.find(b=>b.dataset.need===need).textContent.toLowerCase());
  if(persist){const u=new URL(location.href);if(need==='all')u.searchParams.delete('need');else u.searchParams.set('need',need);history.replaceState({},'',u)}
 }
 buttons.forEach(b=>b.addEventListener('click',()=>filter(b.dataset.need,true)));
 filter(new URL(location.href).searchParams.get('need')||'all');
});
function showImage(src,alt){
 const img=$('.main-product img');if(!img)return;
 img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=src;img.alt=alt;
 const link=$('.gallery>.text-link');if(link)link.href=src;
}
$$('.thumbnails button').forEach((btn,index)=>btn.addEventListener('click',()=>{
 const src=$('img',btn).src.replace(/([?&])width=\d+/,'$1width=900');
 showImage(src,($('[data-product-title]')?.textContent||'Product')+', image '+(index+1));
 $$('.thumbnails button').forEach(b=>{b.classList.toggle('selected',b===btn);b.setAttribute('aria-pressed',String(b===btn))});
}));
// Let a horizontal drag select a photo without blocking page scrolling or pinch zoom.
$$('.pdp .gallery').forEach(gallery=>{
 const stage=$('.main-product',gallery),strip=$('.thumbnails',gallery),buttons=$$('.thumbnails button',gallery);
 if(!stage||buttons.length<2)return;
 stage.style.touchAction='pan-y pinch-zoom';
 stage.querySelectorAll('img').forEach(img=>img.draggable=false);
 let start=null;
 stage.addEventListener('pointerdown',event=>{
  if(!event.isPrimary){start=null;return;}
  if(event.button!==0)return;
  start={id:event.pointerId,x:event.clientX,y:event.clientY};
  stage.setPointerCapture(event.pointerId);
 });
 stage.addEventListener('pointercancel',()=>{start=null;});
 stage.addEventListener('lostpointercapture',()=>{start=null;});
 stage.addEventListener('pointerup',event=>{
  if(!start||event.pointerId!==start.id)return;
  const dx=event.clientX-start.x,dy=event.clientY-start.y;
  start=null;
  if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)*1.25)return;
  let current=buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true');
  if(current<0)current=0;
  const next=Math.max(0,Math.min(buttons.length-1,current+(dx<0?1:-1)));
  if(next===current)return;
  buttons[next].click();
  const target=buttons[next].getBoundingClientRect(),rail=strip.getBoundingClientRect();
  if(target.left<rail.left||target.right>rail.right){
   strip.scrollBy({left:target.left-rail.left-(rail.width-target.width)/2,behavior:'instant'});
  }
 });
});
// Reserve room below desktop media for the complete thumbnail row.
$$('.pdp .gallery').forEach(gallery=>{
 const stage=$('.main-product',gallery),thumbnails=$('.thumbnails',gallery);
 if(!stage||!thumbnails)return;
 let frame=0;
 const fit=()=>{
  frame=0;
  if(!matchMedia('(min-width:901px)').matches){gallery.style.removeProperty('--pc-desktop-media-size');return;}
  const rect=gallery.getBoundingClientRect(),style=getComputedStyle(thumbnails);
  const row=thumbnails.getBoundingClientRect().height+(parseFloat(style.marginTop)||0)+(parseFloat(style.marginBottom)||0);
  const top=rect.top+window.scrollY;
  const size=Math.floor(Math.min(rect.width,Math.max(120,window.innerHeight-top-row-20)));
  const value=size+'px';
  if(gallery.style.getPropertyValue('--pc-desktop-media-size')!==value)gallery.style.setProperty('--pc-desktop-media-size',value);
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(fit);};
 fit();window.addEventListener('resize',schedule,{passive:true});
 if(document.fonts)document.fonts.ready.then(schedule);
 if('ResizeObserver'in window){const observer=new ResizeObserver(schedule);[gallery,thumbnails,$('.header'),$('.announcement'),$('.breadcrumb')].filter(Boolean).forEach(el=>observer.observe(el));}
});
// Select one video asset for the active screen size; retain time when resized.
$$('[data-responsive-vet]').forEach(video=>{
 const mq=matchMedia('(max-width:700px)');
 const choose=()=>{
  const src=mq.matches?video.dataset.mobileSrc:video.dataset.desktopSrc;
  if(video.getAttribute('src')===src)return;
  const time=video.currentTime||0,playing=!video.paused;
  video.pause();video.poster=mq.matches?video.dataset.mobilePoster:video.dataset.desktopPoster;
  video.src=src;video.dataset.orientation=mq.matches?'portrait':'landscape';
  if(time||playing)video.addEventListener('loadedmetadata',()=>{video.currentTime=Math.min(time,video.duration||time);if(playing)video.play().catch(()=>{});},{once:true});
  video.load();
 };
 choose();mq.addEventListener('change',choose);
});
const stories=$('#customer-stories'),storyToggle=$('.pc-stories-toggle');
if(stories&&storyToggle){
 const mq=matchMedia('(min-width:901px)');let expanded=false;
 const sync=()=>{storyToggle.hidden=!mq.matches;stories.classList.toggle('pc-stories-collapsed',mq.matches&&!expanded);storyToggle.setAttribute('aria-expanded',String(expanded));storyToggle.textContent=expanded?'Show three stories ↑':'See all six stories ↓';if(mq.matches&&!expanded)$$('.glow-grid>figure:nth-child(n+4) video',stories).forEach(v=>v.pause());};
 storyToggle.addEventListener('click',()=>{expanded=!expanded;sync()});mq.addEventListener('change',sync);sync();
}
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.getAttribute('aria-expanded')==='true'){$('#mobile-navigation').hidden=true;menu.setAttribute('aria-expanded','false');menu.focus();}});
const form=$('#pc-product-form');if(!form)return;
const data=JSON.parse($('#pc-live-product').textContent),variantInput=$('#pc-variant'),planInput=$('#pc-plan'),qtyInput=$('#pc-quantity'),weight=$('#weight');
const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency||'USD'}).format(n/100);
const variant=()=>data.variants.find(v=>String(v.id)===variantInput.value)||data.variants[0];
const modes=$$('.pc-purchase-modes input',form),modeFields=$('.pc-purchase-modes',form),cadence=$('.pc-cadence',form);let plansReady=false;
const backBlock=document.querySelector('[data-pc-back]');if(backBlock&&new URL(location.href).searchParams.get('back')==='1'){backBlock.hidden=false;try{sessionStorage.setItem('pc_back','1')}catch(e){}}
const perUnit=data.title.toLowerCase().includes('bundle')?'bundle':(weight?'jar':'bag');
const cadenceText=a=>{
 const value=a.options?.map(o=>o.value).join(', ')||a.name;
 if(/^month$/i.test(value))return 'Every month';
 if(/^\d+ months?$/i.test(value))return 'Every '+value.toLowerCase();
 return a.name;
};
function renewalTerms(a,q=1){
 const adjustments=a.adjustments||[];
 if(adjustments.length<2)return money(a.price*q)+' per delivery';
 return adjustments.slice(1).map((adj,i)=>{
  const before=a.planAdjustments?.[i]?.order_count;
  return money(adj.price*q)+(before?' after '+before+' order'+(before===1?'':'s'):' for subsequent orders');
 }).join('; ');
}

// Shared purchase summary: display allocation money, never recreate discounts in the browser.
const stack=$('[data-subscription-stack]',form),refillWeight=$('#pc-refill-weight',form);
function intervalDays(a){
 const raw=(a.options?.map(o=>o.value).join(' ')||a.name).toLowerCase().trim();
 if(raw==='monthly'||raw==='month')return 30.4375;
 const match=raw.match(/(?:every\s+)?(\d+)\s*(day|week|month)s?/);
 return match?Number(match[1])*({day:1,week:7,month:30.4375}[match[2]]):null;
}
function refillChoice(v,q){
 if(!refillWeight||refillWeight.value==='')return null;
 const days=Math.floor(140*q/(Number(refillWeight.value)+1));
 const choices=v.allocations.map(a=>({a,days:intervalDays(a)})).filter(x=>x.days&&x.days<=days-3).sort((x,y)=>y.days-x.days);
 return {days,choice:choices[0]||null};
}
function updateStack(v,a,q){
 if(!stack)return;
 stack.hidden=false;
 const unit=a?a.price:v.price;
 $('[data-stack-product]',stack).textContent=q+' × '+($('[data-product-title]')?.textContent.trim()||$('h1')?.textContent.trim()||data.title)+(v.title!=='Default Title'?' · '+v.title:'');
 $('[data-stack-retail]',stack).textContent=money(v.price*q);
 $('[data-stack-saving-row]',stack).hidden=!a||a.price>=v.price;
 $('[data-stack-saving]',stack).textContent='−'+money(Math.max(0,v.price-unit)*q);
 $('[data-stack-shipping-row]',stack).hidden=!a;
 $('[data-stack-total-label]',stack).textContent=a?'First order':'One-time subtotal';
 $('[data-stack-total]',stack).textContent=money(unit*q);
 $('[data-stack-renewal]',stack).textContent=a?'Then '+renewalTerms(a,q)+'. '+cadenceText(a)+'. Applicable tax calculated at checkout.':'No automatic refills. Shipping and tax calculated at checkout.';
 $('[data-purchase-shipping]',form).textContent=a?'Free subscriber shipping':'Free shipping on orders over $49';
 const refillHelper=$('[data-refill-helper]',stack);if(refillHelper)refillHelper.hidden=!a;
 $('.pc-subscription-help',form).hidden=!a;
 if(!refillHelper)return;
 const advice=$('[data-refill-advice]',stack),apply=$('[data-refill-apply]',stack),refill=refillChoice(v,q);
 apply.hidden=true;
 if(!refill){advice.textContent='Jar duration depends on the daily serving. You can change the delivery interval above.';return;}
 const daily=Number(refillWeight.value)+1;
 advice.textContent=q+' jar'+(q===1?'':'s')+' provides '+refill.days+' full days at '+daily+' chew'+(daily===1?'':'s')+' per day. ';
 if(refill.choice){
  const suggested=refill.choice.a,early=refill.days-refill.choice.days;
  advice.textContent+='Suggested available schedule: '+cadenceText(suggested).toLowerCase()+'. ';
  if(early>10)advice.textContent+='This can arrive before you run out. Check your supply and reschedule or skip using your subscription email. ';
  else advice.textContent+='Leave time for shipping and adjust your next delivery if needed. ';
  if(String(suggested.id)!==planInput.value){apply.hidden=false;apply.textContent='Use '+cadenceText(suggested).toLowerCase();apply.dataset.plan=String(suggested.id);}
 }else advice.textContent+='No available interval matches this supply. Choose an interval above and arrange the next delivery using your subscription email.';
}
if(refillWeight){
 refillWeight.addEventListener('change',()=>{if(refillWeight.value!==''&&weight){weight.value=refillWeight.value;const other=$('.value-weight select');if(other)other.value=weight.value;}update();});
 $('[data-refill-apply]',form).addEventListener('click',event=>{const id=event.currentTarget.dataset.plan;if(variant().allocations.some(a=>String(a.id)===id)){planInput.value=id;update();}});
}

function plans(){
 const v=variant(),previous=planInput.value;
 planInput.replaceChildren();
 if(!data.requiresPlan)planInput.add(new Option('One-time purchase — '+money(v.price),''));
 v.allocations.forEach(a=>planInput.add(new Option(cadenceText(a)+' — '+money(a.price)+' first order',a.id)));
 if([...planInput.options].some(o=>o.value===previous))planInput.value=previous;
 $('.pc-plan-controls').hidden=v.allocations.length===0;
 modeFields.hidden=v.allocations.length===0;
 if(data.requiresPlan&&v.allocations.length&&!planInput.value)planInput.value=String(v.allocations[0].id);
 if(!plansReady&&!data.requiresPlan&&v.allocations.length&&!planInput.value){
  const url=new URL(location.href),wanted=url.searchParams.get('selling_plan'),once=url.searchParams.get('purchase')==='once';
  const match=wanted&&v.allocations.find(x=>String(x.id)===wanted);
  if(!once)planInput.value=String((match||v.allocations[0]).id);
 }
 plansReady=true;
 update();
}
function update(){
 const v=variant(),a=v.allocations.find(x=>String(x.id)===planInput.value),q=Math.max(1,Math.min(99,Number(qtyInput.value)||1)),daily=weight?Number(weight.value)+1:0,unit=a?a.price:v.price;
 const candidate=a||v.allocations[0];
 form.dataset.mode=a?'subscribe':'once';
 modes.forEach(input=>input.checked=input.value===(a?'subscribe':'once'));
 cadence.hidden=!a; $('[data-cadence-label]').textContent='Delivery interval';
 [...planInput.options].forEach(option=>option.hidden=option.value==='');
 const once=$('[data-once-price]');if(once)once.textContent=money(v.price);
 if(candidate){
  $('[data-sub-price]').textContent=money(candidate.price);
  $('[data-sub-preview]').textContent='First order · then '+renewalTerms(candidate);
  const saving=$('[data-sub-saving]'),renewal=$('[data-renewal-benefit]');
  const firstSaving=v.price>0?Math.round((v.price-candidate.price)/v.price*100):0;
  if(saving){saving.hidden=firstSaving<=0;saving.textContent=firstSaving>0?'Save '+firstSaving+'% on your first order':'';}
  const prices=candidate.adjustments||[],repeatPrice=prices.length===2?prices[1].price:prices.length<2?candidate.price:null;
  const repeatSaving=repeatPrice!==null&&v.price>0?Math.round((v.price-repeatPrice)/v.price*100):0;
  if(renewal){renewal.hidden=repeatSaving<=0;renewal.textContent=repeatSaving>0?'Save '+repeatSaving+'% on repeat deliveries':'';}
 }
 let terms='One-time purchase. No automatic refill.';
 if(a){
  terms=cadenceText(a)+'. '+money(a.price)+' per '+perUnit+' for the first order. Then '+renewalTerms(a)+'. Renews until cancelled. Manage future deliveries using the link in your order email.';
  if(daily)terms+=' At the selected serving, one jar lasts '+Math.floor(140/daily)+' full days. Choose an interval that fits your routine.';
 }
 $('.pc-plan-description').textContent=terms;
 updateStack(v,a,q);
 $('[data-live-total]').textContent=money(unit*q);
 $('[data-live-basis]').textContent=(q>1?q+' × '+money(unit)+' · ':'')+(a?'first order':'one-time');
 $('[data-add-label]').textContent=v.available?(stack&&a?'Subscribe — ':'Add to bag — ')+money(unit*q):'Sold out';
 $('button[type=submit]',form).disabled=!v.available||(data.requiresPlan&&!a);
 const sticky=$('.mobile-buy-sticky');
 if(sticky){$('span',sticky).firstChild.textContent=$('[data-product-title]')?.textContent||data.title;$('.mobile-buy-sticky small').textContent=money(unit*q)+(a?' first order · '+cadenceText(a):' one-time');}
 if(daily){
  const results=$$('.serving-results b');[daily,Math.floor(140/daily),money(unit*daily/140),money(unit/140)].forEach((t,i)=>{if(results[i])results[i].textContent=t});
  const value=$$('.value-panel strong'),firstSub=a||v.allocations[0];
  [140,Math.floor(140/daily)+' days',money(v.price*daily/140),firstSub?money(firstSub.price*daily/140):'—',money(v.price/140),firstSub?money(firstSub.price/140):'—'].forEach((t,i)=>{if(value[i])value[i].textContent=t});
  const desc=$$('.value-panel span')[1];if(desc)desc.textContent=weight.options[weight.selectedIndex].text+' · '+daily+' chews a day';
  const note=$('[data-live-value-note]');if(note)note.textContent=(140%daily?Math.floor(140/daily)+' full servings, '+140%daily+' chews left. ':'')+'One-time: '+money(v.price)+' per jar. '+(firstSub?cadenceText(firstSub)+': '+money(firstSub.price)+' first order; then '+renewalTerms(firstSub)+'. ':'')+'Daily cost = jar price ÷ 140 × daily chews. Shipping and tax excluded.';
 }
 const ctx=$('.label-context strong');if(ctx)ctx.textContent=v.title;
}
modes.forEach(input=>input.addEventListener('change',()=>{
 if(input.value==='once')planInput.value='';
 else if(!planInput.value)planInput.value=String(variant().allocations[0]?.id||'');
 update();
}));
variantInput.addEventListener('change',()=>{plans();const v=variant();
 const scienceCard=$('.thumbnails [data-science-card]');
 if(scienceCard){const source=v.title.toLowerCase()==='beef'?scienceCard.dataset.beefSrc:scienceCard.dataset.baconSrc;const thumb=$('img',scienceCard);if(source&&thumb){thumb.src=source;thumb.alt=data.title+' — '+v.title+' ingredient science';}}
 const flavorCard=$('.thumbnails [data-flavor-card]');
 if(flavorCard){const flavor=v.title.toLowerCase(),source=flavor==='beef'?flavorCard.dataset.beefSrc:flavorCard.dataset.baconSrc;const thumb=$('img',flavorCard);if(source&&thumb){thumb.src=source;thumb.alt=data.title+' — '+v.title+' flavored soft chews';}}
 if(v.image){
 const alt=data.title+' — '+v.title,hero=$('.thumbnails [data-variant-hero]');
 if(hero){const thumb=$('img',hero),url=new URL(v.image,location.href);url.searchParams.set('width','160');thumb.src=url.href;thumb.alt=alt;hero.setAttribute('aria-label','View '+v.title+' product photo');}
 showImage(v.image,alt);
 $$('.thumbnails button').forEach(b=>{const selected=b===hero;b.classList.toggle('selected',selected);b.setAttribute('aria-pressed',String(selected))});
}const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)});planInput.addEventListener('change',update);qtyInput.addEventListener('input',update);
if(weight)weight.addEventListener('change',()=>{if(refillWeight)refillWeight.value=weight.value;const other=$('.value-weight select');if(other)other.value=weight.value;update()});const other=$('.value-weight select');if(other)other.addEventListener('change',()=>{weight.value=other.value;if(refillWeight)refillWeight.value=weight.value;update()});
$$('[data-one-time]').forEach(a=>a.addEventListener('click',()=>{planInput.value='';qtyInput.value='1';update()}));
let adding=false;
form.addEventListener('submit',async event=>{
 event.preventDefault();if(adding)return;
 const button=$('button[type=submit]',form),error=$('.pc-cart-error',form);
 const controls=$$('input,select,button',form),disabled=new Map(controls.map(control=>[control,control.disabled]));
 adding=true;controls.forEach(control=>control.disabled=true);error.textContent='';$('[data-add-label]').textContent='Adding…';
 try{
  const item={id:Number(variantInput.value),quantity:Math.max(1,Math.min(99,Number(qtyInput.value)||1))};
  if(planInput.value)item.selling_plan=Number(planInput.value);
  const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:JSON.stringify({items:[item]}),headers:{Accept:'application/json','Content-Type':'application/json'}});
  const result=await response.json().catch(()=>({}));
  if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
  if(window.PCCart)await window.PCCart.open({added:true,returnFocus:button});
  else location.assign((window.Shopify?.routes?.root||'/')+'cart');
 }catch(err){error.textContent=err.message;}
 finally{adding=false;disabled.forEach((state,control)=>control.disabled=state);update();}
});
plans();
const sticky=$('.mobile-buy-sticky'),addButton=$('button[type=submit]',form);
if(sticky&&'IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting},{threshold:.25});observer.observe(addButton);}
})();
